<ion-card class="card-shadow-7"
                style="border-radius: 0.5em;height: 100%;"
               >
               <ion-card-content>
               <ion-grid class="ion-no-padding" style="color: black; min-height: 200px;">
                <ion-row>
                  <ion-col  style="padding: 0.4em;">
                    <ion-label class="card-header-unique"> {{vehicle.ProvName}} | {{vehicle.PlateType.TypeName}}</ion-label>
                  </ion-col>
                  <ion-col size="2" style="text-align: right;" *ngIf="vehicle.electric_vehicle==1 || vehicle.electric_vehicle==true">
                    <ion-icon name="flash"></ion-icon>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col >
                    <ion-grid>
                      <ion-row *ngIf="vehicle.Plate"  style="margin-bottom: 0.2em;">
                        <ion-col >
                          <ion-label class="paragraph-bold">{{vehicle.Plate}}</ion-label>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="vehicle.TypeName">
                        <ion-col>
                         <ion-label class="card-text-regular">{{vehicle.TypeName}} </ion-label>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="vehicle.Year" >
                        <ion-col>
                         <ion-label class="card-text-regular">{{vehicle.Year}}</ion-label>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="vehicle.MakeName" >
                        <ion-col>
                         <ion-label class="card-text-regular">{{('keys.data.vehicles.make' | translate : {Default:'Make'}) || 'Make'}} </ion-label>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="vehicle.ColourName">
                        <ion-col>
                         <ion-label class="card-text-regular">{{vehicle.ColourName}}</ion-label>
                        </ion-col>
                      </ion-row>
                     
                    </ion-grid>
                    
                  </ion-col>
                  <!-- <ion-col *ngIf="vehicle.TypeName" size="4" style="text-align: right;">
                    <img style="max-width: 125px;max-height: 125px;" *ngIf="vehicle.TypeName.toLowerCase()=='sedan'" src="assets/images/sedan.png">
                    <img style="max-width: 125px;max-height: 125px;" *ngIf="vehicle.TypeName.toLowerCase()=='bus'" src="assets/images/bus 1.png">
                    <img style="max-width: 125px;max-height: 125px;" *ngIf="vehicle.TypeName.toLowerCase()=='pickup truck'" src="assets/images/pickup.png">
                    <img style="max-width: 125px;max-height: 125px;" *ngIf="vehicle.TypeName.toLowerCase()=='station wagon'" src="assets/images/station 1.png">
                    <img style="max-width: 125px;max-height: 125px;" *ngIf="vehicle.TypeName.toLowerCase()=='sports car'" src="assets/images/sport car.png">
                    <img style="max-width: 125px;max-height: 125px;" *ngIf="vehicle.TypeName.toLowerCase()=='motorcycle'" src="assets/images/motorcycle.png">
                    <img style="max-width: 125px;max-height: 125px;" *ngIf="vehicle.TypeName.toLowerCase()=='hatchback' || vehicle.TypeName.toLowerCase()=='compact' || vehicle.TypeName.toLowerCase()=='sport utility vehicle'" src="assets/images/hatchback.png">
                    <img style="max-width: 125px;max-height: 125px;" *ngIf="vehicle.TypeName.toLowerCase()=='bicycle'" src="assets/images/bike 1.png">
                    <img style="max-width: 125px;max-height: 125px;" *ngIf="vehicle.TypeName.toLowerCase()=='mini van' || vehicle.TypeName.toLowerCase()=='van' || vehicle.TypeName.toLowerCase()=='cargo van' || vehicle.TypeName.toLowerCase()=='mid-size'" src="assets/images/minivan.png">
                  </ion-col>  -->
                </ion-row>
                
               <ion-row style="position: absolute; bottom: 0; width: 90%;">
                <ion-col size="12" >
                  <ion-item style="--background:transparent"
          *ngIf="vehiclesSRV.loadingToggleChange.value == false"
          lines="none"
        >
          <ion-label class="card-text-bold" *ngIf="vehicle.Active==true"
            >{{ ('keys.data.common.active' | translate : {Default:'Active'}) ||
            "Active"}}</ion-label
          > 
          <ion-label class="card-text-bold" *ngIf="!vehicle.Active || vehicle.Active == false"
            >{{ ('keys.data.common.inactive' | translate : {Default:'Inactive'}) ||
            "Inactive"}}</ion-label
          >
          <ion-toggle color="secondary"
            (ionChange)="vehiclesSRV.onToggleActive($event, vehicle.VehicleID)"
            [checked]="vehicle.Active"
          >
          </ion-toggle>
        </ion-item>
        <ion-item style="--background:transparent" *ngIf="vehiclesSRV.loadingToggleChange.value == true" lines="none">
          <ion-spinner
            style="display: block; margin: auto"
            name="crescent"
          ></ion-spinner>
        </ion-item>
                </ion-col>
               </ion-row>
               
               </ion-grid>
              </ion-card-content>
                 </ion-card>